import { render } from "./WisenheimerView.vue?vue&type=template&id=6ea060f2&scoped=true"
import script from "./WisenheimerView.vue?vue&type=script&lang=js"
export * from "./WisenheimerView.vue?vue&type=script&lang=js"

import "./WisenheimerView.vue?vue&type=style&index=0&id=6ea060f2&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/hosts/mageix.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea060f2"]])

export default __exports__